import * as types from './notificationActionTypes.js';

export const setCounter = (counter) => ({ type: types.SET_COUNTER, counter: counter });
export const incrementCounter = () => ({ type: types.INCREMENT_COUNTER });
